import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowShipmentDashboard } from "../../utils";

function RestrictShipmentDashboard(props) {
  if (IsShowShipmentDashboard()) return props.children;
  return <NotAccess />;
}

export default RestrictShipmentDashboard;
